// extracted by mini-css-extract-plugin
module.exports = {"container":"Satisfaction_container__QMo3C","title":"Satisfaction_title__2jp9T","img":"Satisfaction_img__2LDLF","text":"Satisfaction_text__aYPGn"};